import React from 'react'

interface QuantityStepperProps {
  label: string
  value: number
  min?: number
  max: number
  disabled?: boolean
  onChange: (value: number) => void
  labelledById?: string
}

export const QuantityStepper: React.FC<QuantityStepperProps> = ({
  label,
  value,
  min = 1,
  max,
  disabled = false,
  onChange,
  labelledById = 'quantity-stepper-label',
}) => (
  <div
    className='d-inline-flex align-items-center gap-2 border rounded shadow-sm bg-white px-3 py-2'
    role='group'
    aria-labelledby={labelledById}
  >
    <label className='form-label mb-0 me-1' id={labelledById}>
      {label}
    </label>
    <span
      className='d-inline-flex align-items-center justify-content-center fw-semibold'
      style={{width: '2ch', fontSize: '1.05rem'}}
      aria-live='polite'
    >
      {value}
    </span>
    <div className='d-flex flex-column'>
      <button
        type='button'
        className='btn btn-sm btn-outline-secondary px-1 py-0 lh-1'
        aria-label={`Increase ${label.toLowerCase()}`}
        disabled={disabled || value >= max}
        onClick={() => onChange(Math.min(max, value + 1))}
      >
        <i className='fas fa-chevron-up' style={{fontSize: '0.65rem'}} aria-hidden='true' />
      </button>
      <button
        type='button'
        className='btn btn-sm btn-outline-secondary px-1 py-0 lh-1'
        aria-label={`Decrease ${label.toLowerCase()}`}
        disabled={disabled || value <= min}
        onClick={() => onChange(Math.max(min, value - 1))}
      >
        <i className='fas fa-chevron-down' style={{fontSize: '0.65rem'}} aria-hidden='true' />
      </button>
    </div>
  </div>
)
